var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.remindList.length === 0
        ? _c("div", { staticStyle: { color: "grey" } }, [
            _vm._v("暂无催款信息"),
          ])
        : _vm._e(),
      _vm._l(_vm.remindList, function (item, index) {
        return _c(
          "el-row",
          { key: index, staticStyle: { padding: "10px" } },
          [
            _c(
              "el-card",
              { staticStyle: { height: "120px" }, attrs: { shadow: "never" } },
              [
                _c("el-col", { attrs: { span: 12 } }, [
                  _c("div", { staticStyle: { "font-size": "16px" } }, [
                    _vm._v(
                      "第" + _vm._s(_vm.remindList.length - index) + "次催单"
                    ),
                  ]),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "margin-top": "5px",
                        "font-size": "12px",
                        color: "#b5b4bf",
                      },
                    },
                    [_vm._v(_vm._s(item.sremindTime))]
                  ),
                  item.sreplayCode === "1"
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            "margin-top": "5px",
                            "font-size": "16px",
                          },
                        },
                        [_vm._v("备货中")]
                      )
                    : _vm._e(),
                  item.sreplayCode === "2"
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            "margin-top": "5px",
                            "font-size": "16px",
                          },
                        },
                        [_vm._v("已送出")]
                      )
                    : _vm._e(),
                  item.sreplayCode === "3"
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            "margin-top": "5px",
                            "font-size": "16px",
                          },
                        },
                        [_vm._v("天气原因")]
                      )
                    : _vm._e(),
                  item.sreplayCode === "6"
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            "margin-top": "5px",
                            "font-size": "16px",
                          },
                        },
                        [_vm._v(_vm._s(item.sreplayMsg))]
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "margin-top": "5px",
                        "font-size": "12px",
                        color: "#b5b4bf",
                      },
                    },
                    [_vm._v(_vm._s(item.treplay + " " + item.sreplay))]
                  ),
                ]),
                _c(
                  "el-col",
                  {
                    staticStyle: { "text-align": "right" },
                    attrs: { span: 12 },
                  },
                  [
                    item.status === 1
                      ? _c(
                          "el-dropdown",
                          { on: { command: _vm.handleReplay } },
                          [
                            _c("el-button", { attrs: { type: "primary" } }, [
                              _vm._v("回复用户"),
                              _c("i", {
                                staticClass:
                                  "el-icon-arrow-down el-icon--right",
                              }),
                            ]),
                            _c(
                              "el-dropdown-menu",
                              { attrs: { slot: "dropdown" }, slot: "dropdown" },
                              [
                                _c(
                                  "el-dropdown-item",
                                  { attrs: { command: "1" } },
                                  [_vm._v("备货中")]
                                ),
                                _c(
                                  "el-dropdown-item",
                                  { attrs: { command: "2" } },
                                  [_vm._v("已送出")]
                                ),
                                _c(
                                  "el-dropdown-item",
                                  { attrs: { command: "3" } },
                                  [_vm._v("天气原因")]
                                ),
                                _c(
                                  "el-dropdown-item",
                                  { attrs: { command: "6" } },
                                  [_vm._v("自定义")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _c(
                          "el-button",
                          { attrs: { type: "info", plain: "" } },
                          [_vm._v("已回复")]
                        ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              [
                _c("el-input", {
                  staticClass: "marginTop5",
                  attrs: { type: "textarea" },
                  model: {
                    value: _vm.replyContent,
                    callback: function ($$v) {
                      _vm.replyContent = $$v
                    },
                    expression: "replyContent",
                  },
                }),
              ],
              1
            ),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }